import { AbstractProgramModel } from "@app/catalog-common";

export class ProgramNotFoundMessage {
    
    public program: AbstractProgramModel;
    
    constructor(program: AbstractProgramModel)
    {
        this.program = program;
    }
}